module.exports = __webpack_public_path__ + "static/media/typeService.1b7fbb70.svg";